import './ResultadoEbrHero.css';

function claseChipRiesgoSectorial(riesgo) {
    const key = String(riesgo || '').toLowerCase().trim();
    if (key === 'bajo') return 'ebr-hero__chip--bajo';
    if (key === 'medio-bajo') return 'ebr-hero__chip--medio-bajo';
    if (key === 'medio') return 'ebr-hero__chip--medio';
    if (key === 'alto') return 'ebr-hero__chip--alto';
    return 'ebr-hero__chip--default';
}

function claseNivelResidual(nivel) {
    if (!nivel) return '';
    if (String(nivel).toUpperCase().includes('BAJO')) return 'ebr-hero__nivel--bajo';
    return 'ebr-hero__nivel--elevado';
}

/**
 * Bloque principal del resultado EBR (solo presentación).
 */
export default function ResultadoEbrHero({
    nombreActividad,
    riesgoSectorial,
    nivelResidual,
}) {
    const riesgoTexto = riesgoSectorial
        ? String(riesgoSectorial).toUpperCase()
        : '—';
    const nivelTexto = nivelResidual
        ? String(nivelResidual).toUpperCase()
        : '—';

    return (
        <section className="ebr-hero" aria-labelledby="ebr-hero-title">
            <div className="ebr-hero__inner">
                <div className="ebr-hero__eyebrow">
                    <span className="ebr-hero__eyebrow-dot" aria-hidden="true" />
                    Resultados
                </div>

                <h2 id="ebr-hero-title" className="ebr-hero__title">
                    Evaluación - Enfoque Basado en Riesgos (EBR)
                </h2>

                <div className="ebr-hero__grid">
                    <div className="ebr-hero__panel">
                        <span className="ebr-hero__panel-label">Evaluación Nacional de Riesgos</span>
                        <p className="ebr-hero__actividad">{nombreActividad}</p>
                        <span className={`ebr-hero__chip ${claseChipRiesgoSectorial(riesgoSectorial)}`}>
                            Riesgo sectorial: {riesgoTexto}
                        </span>
                    </div>

                    <div className="ebr-hero__connector" aria-hidden="true">→</div>

                    <div className="ebr-hero__panel ebr-hero__panel--highlight">
                        <span className="ebr-hero__panel-label">Tu matriz institucional</span>
                        <p className={`ebr-hero__nivel ${claseNivelResidual(nivelResidual)}`}>
                            {nivelTexto}
                        </p>
                    </div>
                </div>

                <p className="ebr-hero__narrative">
                    De acuerdo con la Evaluación Nacional de Riesgos, la actividad{' '}
                    <b>{nombreActividad}</b> se considera de{' '}
                    <b className="text-uppercase">{riesgoTexto}</b>. Según tu matriz puedes considerarte de resgo{' '}
                    <b className="text-uppercase">{nivelTexto}</b>.
                </p>
            </div>
        </section>
    );
}
